export default __webpack_public_path__ + "static/media/download.73dfa82a.jpg";